import { render, staticRenderFns } from "./OtherWorkCard.vue?vue&type=template&id=1a9cf840&scoped=true"
import script from "./OtherWorkCard.vue?vue&type=script&lang=js"
export * from "./OtherWorkCard.vue?vue&type=script&lang=js"
import style0 from "./OtherWorkCard.vue?vue&type=style&index=0&id=1a9cf840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9cf840",
  null
  
)

export default component.exports